import { render, staticRenderFns } from "./site_description.vue?vue&type=template&id=27fe42df&scoped=true&"
import script from "./site_description.vue?vue&type=script&lang=js&"
export * from "./site_description.vue?vue&type=script&lang=js&"
import style0 from "./site_description.vue?vue&type=style&index=0&id=27fe42df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe42df",
  null
  
)

export default component.exports